import i18n from '@/i18n/index'

export const public_routes = [
  { path: '/', redirect: '/auth' },
  {
    name: i18n.t('route.login'),
    path: '/',
    component: () => import('@/views/User/UserIndex.vue'),
    children: [
      {
        path: '/login',
        name: i18n.t('route.administratorLogin'),
        component: () => import('@/views/User/UserLogin.vue'),
      },
      {
        path: '/reset_password',
        name: i18n.t('route.resetPassword'),
        component: () => import('@/views/User/UserResetPwd.vue'),
      },
      {
        path: '/forget_password',
        name: i18n.t('route.forgotPassword'),
        component: () => import('@/views/User/UserForgetPwd.vue'),
      },
      {
        path: '/auth',
        name: i18n.t('route.login'),
        component: () => import('@/views/User/UserAuth.vue'),
      },
      {
        name: i18n.t('route.impersonationMode'),
        path: '/user_impersonate',
        component: () => import('@/views/User/UserImpersonate.vue'),
      },
    ],
  },
  {
    path: '/embed/timer',
    name: i18n.t('route.countdownTimer'),
    component: () => import('@/views/OptimizePage/IframeTimer/TimerPubicIFrame.vue'),
    meta: {
      is_required_login: false,
    },
  },
  {
    path: '/embed/invoice_collector',
    name: i18n.t('route.invoiceCollector'),
    component: () => import('@/views/OptimizePage/InvoiceCollector/PublicIframe.vue'),
  },
  {
    path: '/subscription/plan',
    name: i18n.t('route.subscriptionPlan'),
    component: () => import('@/views/Setting/Subscription/PublicSubscription.vue'),
    meta: {
      is_required_login: false,
    },
  },
  {
    name: i18n.t('route.login'),
    path: '/cyberbiz/plugin_auth',
    component: () => import('@/views/User/UserInstallCallback.vue'),
    meta: {
      is_required_login: false,
    },
  },
  {
    name: 'Shopline登入驗證',
    path: '/shopline/plugin_auth',
    component: () => import('@/views/User/UserInstallCallback.vue'),
    meta: {
      is_required_login: false,
    },
  },
  {
    name: 'Shopline後台跳轉',
    path: '/shopline/login',
    component: () => import('@/views/User/UserSLBackendLogin.vue'),
    meta: {
      is_required_login: false,
    },
  },
  {
    path: '*',
    component: () => import('@/views/Error/NotFound.vue'),
    redirect: '/login',
    meta: {
      is_required_login: false,
    },
  },
  {
    name: i18n.t('route.bindLineGroup'),
    path: '/bind-line-group',
    component: () => import('@/views/Setting/Container/BindLineGroup.vue'),
  },
]
